/**
 * Well context — the currently-selected well the top-bar switcher points at,
 * plus the active event (job) within that well. The record/report screens read
 * this to know which well and which event to load. Selecting a new well clears
 * the active event so it can't leak across wells.
 */
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface WellContextState {
  selectedWellId: string | null;
  /** Active event id; null means "let the screens pick a sensible default". */
  activeEventId: string | null;
  /** Shared well-search text: the top switcher and the Well Explorer both use it,
   * so typing in the top box filters the Explorer list + map live. */
  wellQuery: string;
}

const initialState: WellContextState = {
  selectedWellId: null,
  activeEventId: null,
  wellQuery: "",
};

const wellContextSlice = createSlice({
  name: "wellContext",
  initialState,
  reducers: {
    selectWell(state, action: PayloadAction<string | null>) {
      if (state.selectedWellId !== action.payload) {
        state.activeEventId = null;
      }
      state.selectedWellId = action.payload;
    },
    setActiveEvent(state, action: PayloadAction<string | null>) {
      state.activeEventId = action.payload;
    },
    setWellQuery(state, action: PayloadAction<string>) {
      state.wellQuery = action.payload;
    },
  },
});

export const { selectWell, setActiveEvent, setWellQuery } = wellContextSlice.actions;
export const wellContextReducer = wellContextSlice.reducer;
